var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCard } from '../card/card-context';
import { Modal } from '../modal';
import { Text } from '../text';
import { countStaticStyle } from './styles';
const counterSizeMap = {
    large: 'medium',
    medium: 'small',
};
function Footer(_a) {
    var { children, count, total } = _a, restProps = __rest(_a, ["children", "count", "total"]);
    const { size } = useCard();
    function renderCount() {
        return count != null && total > 0 ? (_jsx(Text, Object.assign({ css: countStaticStyle, "data-testid": "popover-counter", size: counterSizeMap[size] }, { children: `${count} of ${total}` }))) : null;
    }
    return (_jsxs(Modal.Footer, Object.assign({}, restProps, { children: [renderCount(), children] })));
}
export default Footer;
